import './Snackbar.scss'
import React, { ReactElement } from 'react';
import {
    Snackbar as MaterialUISnackBar,
    SnackbarContent
} from '@mui/material';
import SvgIcon from 'cui/utils/SvgIcon';
import { useAppDispatch, useAppSelector } from 'store/app/hooks';
import { RootState } from 'store/app/store';

import {
    snackbarErrorIcon,
    snackbarInfoIcon,
    snackbarSuccessIcon,
    snackbarWarningIcon} from '../../assets/images/icons';
import {
    closeSnackbar,
    exitSnackbar
} from './Snackbar.slice';
import { SnackbarType } from './Snackbar.types';

export const Snackbar = (): React.ReactElement => {
    const dispatch = useAppDispatch();

    const isSnackbarOpen = useAppSelector(
        (state: RootState) => state.snackbar.isSnackbarOpen
    );

    const snackbarMessage = useAppSelector(
        (state: RootState) => state.snackbar.snackbarMessage
    );

    const snackbarIcons = new Map([
        [SnackbarType.Info, snackbarInfoIcon],
        [SnackbarType.Error, snackbarErrorIcon],
        [SnackbarType.Warning, snackbarWarningIcon],
        [SnackbarType.Success, snackbarSuccessIcon]
    ]);

    const getSnackbarIcons = (type: SnackbarType) : ReactElement => {
        const localSnackbarIcons = snackbarIcons.get(type) as string;
        return <SvgIcon className="snackbarIcon" svg={localSnackbarIcons} />
    };

    const handleExit = (): void => {
        dispatch(exitSnackbar());
    }

    const handleClose = (event: any, reason: string): void => {
        if (reason === 'clickaway') {
            return;
        }
        dispatch(closeSnackbar());
    }

    return (
        <MaterialUISnackBar
            key={snackbarMessage.key}
            anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
            open={isSnackbarOpen}
            onClose={handleClose}
            TransitionProps={{onExited: handleExit}}
            autoHideDuration={
                snackbarMessage.duration > 0
                    ? snackbarMessage.duration
                    : undefined
            }>
                        <SnackbarContent
                            className={snackbarMessage.type}
                            message={
                                <span className='snackbarMessage'>
                                    {getSnackbarIcons(snackbarMessage.type) }
                                    {snackbarMessage.message}
                                </span>
                            }
                        />
                    </MaterialUISnackBar>
                    );
};
